module.exports = __webpack_public_path__ + "media/images/webpage/hotels/93/gym-bbb3e99a5df7964df0b63fd252ebb0ce.webp";